export default "__VITE_ASSET__nTFDkYTM__"